export const deals = {
  data: {
    '646448397996bbe2b288426b': [
      {
        _id: '6603d732ec6060359d14cd1d',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: [],
        leadId: [],
        companyId: null,
        name: 'Test Deal',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 1,
        createdAt: '2024-03-27T08:22:10.783Z',
        updatedAt: '2024-03-27T08:22:10.783Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 2000,
        stageId: '646448397996bbe2b288426b',
        _amount: '2,000.00',
      },
      {
        _id: '65d315412aa5ac23af320c6a',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['64fa831d6c9a7d29383bac1d'],
        leadId: [
          {
            _id: '65c9b5fe43c1c50af7cd09d1',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'John',
            lastName: 'Ardosa',
            fullName: 'John Ardosa',
            emailAddress: 'jardosa+feb_12@leapify.com',
            mobileNumber: null,
          },
        ],
        companyId: {
          _id: '65c9d09643c1c50af7cd0efa',
          name: 'Test Company Feb 12',
          accountId: '63e05fe4d59adc087e305e08',
          industry: 'aerospace',
          type: 'jointVenture',
          createdAt: '2024-02-12T08:02:30.153Z',
          updatedAt: '2024-02-12T08:02:30.153Z',
          trashed: false,
          trashedAt: null,
          __v: 0,
          id: '65c9d09643c1c50af7cd0efa',
        },
        name: 'Deal324',
        type: 'NEW_BUSINESS',
        closedAt: '2024-02-12T16:00:00.000Z',
        sequence: 1,
        createdAt: '2024-02-19T08:45:53.283Z',
        updatedAt: '2024-03-21T08:10:36.987Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 43241,
        stageId: '646448397996bbe2b288426b',
        _amount: '43,241.00',
      },
      {
        _id: '65d3151c2aa5ac23af3205a4',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['63bf972ac560036d9e42b3f6'],
        leadId: [
          {
            _id: '65f1903e49a280b2d15ec5fe',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'John',
            lastName: 'Smith',
            fullName: 'John Smith',
            emailAddress: 'john.smith@leapify.com',
            mobileNumber: null,
          },
          {
            _id: '65f1584f11599b48981a1ad2',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'John',
            lastName: 'Smith',
            fullName: 'John Smith',
            emailAddress: 'john.smith@leapify.com',
            mobileNumber: null,
          },
        ],
        companyId: {
          _id: '65f3bd2378ad926cc7296dd9',
          name: 'Raging Bull',
          accountId: '63e05fe4d59adc087e305e08',
          createdAt: '2024-03-15T03:14:43.365Z',
          updatedAt: '2024-03-15T03:14:43.365Z',
          trashed: false,
          trashedAt: null,
          __v: 0,
          id: '65f3bd2378ad926cc7296dd9',
        },
        name: 'Deal1',
        type: 'NEW_BUSINESS',
        closedAt: '2024-02-11T16:00:00.000Z',
        sequence: 1,
        createdAt: '2024-02-19T08:45:16.127Z',
        updatedAt: '2024-03-18T05:56:26.463Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 34244,
        stageId: '646448397996bbe2b288426b',
        _amount: '34,244.00',
      },
      {
        _id: '65b0c1d5c05b317b48e07c23',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['65b6ed69a911c4189dae854a'],
        leadId: [],
        companyId: null,
        name: 'Test Deal 01-24-24424',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 1,
        createdAt: '2024-01-24T07:52:53.867Z',
        updatedAt: '2024-01-29T00:12:25.703Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 432432,
        stageId: '646448397996bbe2b288426b',
        _amount: '432,432.00',
      },
      {
        _id: '65b0c1abc05b317b48e07607',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['65b212451a94ba591d4e6737'],
        leadId: [
          {
            _id: '65ae053e8a1315809afe275d',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'John',
            lastName: 'Ardosa Jan 22 Edited',
            fullName: 'John Ardosa Jan 22 Edited',
            emailAddress: 'jardosa+01_22_2023@leadorigin.com',
            mobileNumber: null,
          },
        ],
        companyId: null,
        name: 'Deal 2023 Jan 53',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 2,
        createdAt: '2024-01-24T07:52:11.231Z',
        updatedAt: '2024-01-25T07:48:21.638Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 43242,
        stageId: '646448397996bbe2b288426b',
        _amount: '43,242.00',
      },
      {
        _id: '65682fbaed9eb5abe3de0154',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: [],
        leadId: [
          {
            _id: '63d3145386c72e78610443e2',
            accountId: '63e05fe4d59adc087e305e08',
            firstName: 'Steven',
            lastName: 'Spielberg',
            emailAddress: 'steven@dreamworks.com',
            mobileNumber: '+639176475551',
            companyId: null,
            fullName: 'Steven Spielberg',
          },
        ],
        companyId: null,
        name: 'fdsafsdfsadfdasfsadfsadfasdfasdfa',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 3,
        createdAt: '2023-11-30T06:46:18.189Z',
        updatedAt: '2024-01-24T08:43:20.738Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 3123213,
        stageId: '646448397996bbe2b288426b',
        _amount: '3,123,213.00',
      },
    ],
    '646441abd973766a4dd62f28': [
      {
        _id: '65b0bf64c05b317b48e02b9a',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: [],
        leadId: [],
        companyId: null,
        name: 'Test Deal 01-24-2024',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 1,
        createdAt: '2024-01-24T07:42:28.132Z',
        updatedAt: '2024-01-24T08:08:50.520Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 5000,
        stageId: '646441abd973766a4dd62f28',
        _amount: '5,000.00',
      },
      {
        _id: '65c9c80143c1c50af7cd0dd2',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['650d25ebaa987a1bb221f125', '650d00994c7084ecbde8a00a'],
        leadId: [
          {
            _id: '65c9d08743c1c50af7cd0eee',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'Feb 12 Lead',
            lastName: 'Feb 12 Lead',
            fullName: 'Feb 12 Lead Feb 12 Lead',
            emailAddress: 'jardosa+13@leadorigin.com',
            mobileNumber: null,
          },
        ],
        companyId: {
          _id: '65c9d09643c1c50af7cd0efa',
          name: 'Test Company Feb 12',
          accountId: '63e05fe4d59adc087e305e08',
          industry: 'aerospace',
          type: 'jointVenture',
          createdAt: '2024-02-12T08:02:30.153Z',
          updatedAt: '2024-02-12T08:02:30.153Z',
          trashed: false,
          trashedAt: null,
          __v: 0,
          id: '65c9d09643c1c50af7cd0efa',
        },
        name: 'Test Deal Feb 12',
        type: 'NEW_BUSINESS',
        closedAt: '2024-02-20T16:00:00.000Z',
        sequence: 2,
        createdAt: '2024-02-12T07:25:53.472Z',
        updatedAt: '2024-03-21T09:31:08.634Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 20000,
        stageId: '646441abd973766a4dd62f28',
        _amount: '20,000.00',
      },
      {
        _id: '65a4b8e9a93b71a247e43e27',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['64fa9811f9aefd373f7964ae'],
        leadId: [
          {
            _id: '63d3169d86c72e786104449f',
            accountId: '63e05fe4d59adc087e305e08',
            firstName: 'John',
            lastName: 'Smith',
            emailAddress: 'john.smith@yahoo.com',
            mobileNumber: '+18008373612',
            companyId: null,
            fullName: 'John Smith',
          },
          {
            _id: '63d3145386c72e78610443e2',
            accountId: '63e05fe4d59adc087e305e08',
            firstName: 'Steven',
            lastName: 'Spielberg',
            emailAddress: 'steven@dreamworks.com',
            mobileNumber: '+639176475551',
            companyId: null,
            fullName: 'Steven Spielberg',
          },
        ],
        companyId: {
          _id: '65af7a6a63d1530aea0c39ae',
          name: 'Company ABCDE',
          accountId: '63e05fe4d59adc087e305e08',
          industry: 'aerospace',
          type: 'soleProprietorship',
          city: 'San Francisco',
          state: 'California',
          postalCode: '4102',
          noEmployees: null,
          annualRevenue: null,
          timezone: '',
          description: '',
          linkedinUrl: '',
          companyWebsite: '',
          createdAt: '2024-01-23T08:35:54.289Z',
          updatedAt: '2024-01-23T09:22:30.447Z',
          trashed: false,
          trashedAt: null,
          __v: 0,
          id: '65af7a6a63d1530aea0c39ae',
        },
        name: 'Deal Jan 15 2024',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 2,
        createdAt: '2024-01-15T04:47:37.937Z',
        updatedAt: '2024-01-25T07:29:10.002Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 3213122333,
        stageId: '646441abd973766a4dd62f28',
        _amount: '3,213,122,333.00',
      },
    ],
    '646448467996bbe2b288427c': [
      {
        _id: '65b0cd95c05b317b48e1f998',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: [],
        leadId: [],
        companyId: null,
        name: 'Test Deal-01-24-2024-22',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 1,
        createdAt: '2024-01-24T08:43:01.559Z',
        updatedAt: '2024-01-24T08:44:54.396Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 5000,
        stageId: '646448467996bbe2b288427c',
        _amount: '5,000.00',
      },
      {
        _id: '65b0c2a5c05b317b48e097e3',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: [],
        leadId: [],
        companyId: null,
        name: 'Test Deal 01-24-244243',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 2,
        createdAt: '2024-01-24T07:56:21.251Z',
        updatedAt: '2024-01-24T08:43:20.738Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 50003,
        stageId: '646448467996bbe2b288427c',
        _amount: '50,003.00',
      },
      {
        _id: '6568393043c62c975ef855b7',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['65b0b704c05b317b48df1dd6'],
        leadId: [
          {
            _id: '65ae053e8a1315809afe275d',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'John',
            lastName: 'Ardosa Jan 22 Edited',
            fullName: 'John Ardosa Jan 22 Edited',
            emailAddress: 'jardosa+01_22_2023@leadorigin.com',
            mobileNumber: null,
          },
          {
            _id: '658cef5d204e4a27bf58fdd3',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: '658cef5d204e4a27bf58fdcf',
            firstName: 'John',
            lastName: 'Wilkes-Boothes',
            fullName: 'John Wilkes-Boothes',
            emailAddress: 'jardosa+999@leadorigin.com',
            mobileNumber: '',
          },
        ],
        companyId: null,
        name: 'New Deal',
        type: 'EXISTING_BUSINESS',
        closedAt: null,
        sequence: 3,
        createdAt: '2023-11-30T07:26:40.432Z',
        updatedAt: '2024-01-24T08:43:20.738Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 312,
        stageId: '646448467996bbe2b288427c',
        _amount: '312.00',
      },
    ],
    '64f94a605b1334b16062f3fd': [
      {
        _id: '64f944875b1334b16062ee73',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['63bf972ac560036d9e42b3f6'],
        leadId: [
          {
            _id: '63b62efbcef33a72b438ce8b',
            accountId: '63e05fe4d59adc087e305e08',
            firstName: 'Johns',
            lastName: 'Ardosas',
            emailAddress: 'johnArdosa@tacobell.nets',
            mobileNumber: '+639176475551',
            companyId: null,
            fullName: 'Johns Ardosas',
          },
          {
            _id: '6502a83719b8404b74a535a9',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'Lead',
            lastName: 'Four',
            fullName: 'Lead Four',
            emailAddress: 'jardosa+lead_4@leadorigin.com',
            mobileNumber: '',
          },
          {
            _id: '6502a82419b8404b74a53598',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'Lead',
            lastName: 'Three',
            fullName: 'Lead Three',
            emailAddress: 'jardosa+lead_03@leadorigin.com',
            mobileNumber: '',
          },
          {
            _id: '6502a7b919b8404b74a5355e',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'Lead',
            lastName: 'Two',
            fullName: 'Lead Two',
            emailAddress: 'jardosa+lead_02@leadorigin.com',
            mobileNumber: '',
          },
        ],
        companyId: {
          _id: '646324b6f3a89fed15a2c229',
          name: 'Microsofts',
          accountId: '63e05fe4d59adc087e305e08',
          industry: 'computer',
          type: 'corporation',
          city: 'San Francisco',
          state: 'CA',
          postalCode: '90210',
          noEmployees: 10100,
          annualRevenue: null,
          timezone: '',
          description: '',
          linkedinUrl: '',
          companyWebsite: 'www.microsoft.com',
          createdAt: '2023-05-16T06:37:42.128Z',
          updatedAt: '2024-01-23T08:34:49.748Z',
          __v: 0,
          photoUrl:
            'https://ucarecdn.com/48b21a70-ce57-4e46-95d0-b3d6b9acebdd/',
          trashed: false,
          trashedAt: null,
          id: '646324b6f3a89fed15a2c229',
        },
        name: 'Test Deal 2',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 1,
        createdAt: '2023-09-07T03:33:27.034Z',
        updatedAt: '2024-01-04T01:42:08.323Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 500,
        stageId: '64f94a605b1334b16062f3fd',
        _amount: '500.00',
      },
      {
        _id: '6507e6b129cb7b3835108e1d',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['63bf972ac560036d9e42b3f6'],
        leadId: [
          {
            _id: '63b62efbcef33a72b438ce8b',
            accountId: '63e05fe4d59adc087e305e08',
            firstName: 'Johns',
            lastName: 'Ardosas',
            emailAddress: 'johnArdosa@tacobell.nets',
            mobileNumber: '+639176475551',
            companyId: null,
            fullName: 'Johns Ardosas',
          },
        ],
        companyId: {
          _id: '646324b6f3a89fed15a2c229',
          name: 'Microsofts',
          accountId: '63e05fe4d59adc087e305e08',
          industry: 'computer',
          type: 'corporation',
          city: 'San Francisco',
          state: 'CA',
          postalCode: '90210',
          noEmployees: 10100,
          annualRevenue: null,
          timezone: '',
          description: '',
          linkedinUrl: '',
          companyWebsite: 'www.microsoft.com',
          createdAt: '2023-05-16T06:37:42.128Z',
          updatedAt: '2024-01-23T08:34:49.748Z',
          __v: 0,
          photoUrl:
            'https://ucarecdn.com/48b21a70-ce57-4e46-95d0-b3d6b9acebdd/',
          trashed: false,
          trashedAt: null,
          id: '646324b6f3a89fed15a2c229',
        },
        name: 'Test Deal 2',
        type: 'NEW_BUSINESS',
        closedAt: '2023-08-12T16:00:00.000Z',
        sequence: 2,
        createdAt: '2023-09-07T03:33:27.034Z',
        updatedAt: '2024-01-04T01:42:08.323Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 500,
        stageId: '64f94a605b1334b16062f3fd',
        _amount: '500.00',
      },
      {
        _id: '6507e6c029cb7b3835108e1e',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['63bf972ac560036d9e42b3f6'],
        leadId: [
          {
            _id: '63b62efbcef33a72b438ce8b',
            accountId: '63e05fe4d59adc087e305e08',
            firstName: 'Johns',
            lastName: 'Ardosas',
            emailAddress: 'johnArdosa@tacobell.nets',
            mobileNumber: '+639176475551',
            companyId: null,
            fullName: 'Johns Ardosas',
          },
        ],
        companyId: {
          _id: '646324b6f3a89fed15a2c229',
          name: 'Microsofts',
          accountId: '63e05fe4d59adc087e305e08',
          industry: 'computer',
          type: 'corporation',
          city: 'San Francisco',
          state: 'CA',
          postalCode: '90210',
          noEmployees: 10100,
          annualRevenue: null,
          timezone: '',
          description: '',
          linkedinUrl: '',
          companyWebsite: 'www.microsoft.com',
          createdAt: '2023-05-16T06:37:42.128Z',
          updatedAt: '2024-01-23T08:34:49.748Z',
          __v: 0,
          photoUrl:
            'https://ucarecdn.com/48b21a70-ce57-4e46-95d0-b3d6b9acebdd/',
          trashed: false,
          trashedAt: null,
          id: '646324b6f3a89fed15a2c229',
        },
        name: 'Test Deal 2',
        type: 'NEW_BUSINESS',
        closedAt: '2023-07-12T16:00:00.000Z',
        sequence: 3,
        createdAt: '2023-09-07T03:33:27.034Z',
        updatedAt: '2024-01-04T01:42:08.323Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 500,
        stageId: '64f94a605b1334b16062f3fd',
        _amount: '500.00',
      },
      {
        _id: '6507e6c929cb7b3835108e1f',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['63bf972ac560036d9e42b3f6'],
        leadId: [
          {
            _id: '63b62efbcef33a72b438ce8b',
            accountId: '63e05fe4d59adc087e305e08',
            firstName: 'Johns',
            lastName: 'Ardosas',
            emailAddress: 'johnArdosa@tacobell.nets',
            mobileNumber: '+639176475551',
            companyId: null,
            fullName: 'Johns Ardosas',
          },
        ],
        companyId: {
          _id: '646324b6f3a89fed15a2c229',
          name: 'Microsofts',
          accountId: '63e05fe4d59adc087e305e08',
          industry: 'computer',
          type: 'corporation',
          city: 'San Francisco',
          state: 'CA',
          postalCode: '90210',
          noEmployees: 10100,
          annualRevenue: null,
          timezone: '',
          description: '',
          linkedinUrl: '',
          companyWebsite: 'www.microsoft.com',
          createdAt: '2023-05-16T06:37:42.128Z',
          updatedAt: '2024-01-23T08:34:49.748Z',
          __v: 0,
          photoUrl:
            'https://ucarecdn.com/48b21a70-ce57-4e46-95d0-b3d6b9acebdd/',
          trashed: false,
          trashedAt: null,
          id: '646324b6f3a89fed15a2c229',
        },
        name: 'Test Deal 2',
        type: 'NEW_BUSINESS',
        closedAt: '2023-06-12T16:00:00.000Z',
        sequence: 4,
        createdAt: '2023-09-07T03:33:27.034Z',
        updatedAt: '2024-01-04T01:42:08.323Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 500,
        stageId: '64f94a605b1334b16062f3fd',
        _amount: '500.00',
      },
      {
        _id: '64784b2cb061a0e0e2f50aee',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['63bf972ac560036d9e42b3f6'],
        leadId: [
          {
            _id: '63b62efbcef33a72b438ce8b',
            accountId: '63e05fe4d59adc087e305e08',
            firstName: 'Johns',
            lastName: 'Ardosas',
            emailAddress: 'johnArdosa@tacobell.nets',
            mobileNumber: '+639176475551',
            companyId: null,
            fullName: 'Johns Ardosas',
          },
        ],
        companyId: {
          _id: '646324b6f3a89fed15a2c229',
          name: 'Microsofts',
          accountId: '63e05fe4d59adc087e305e08',
          industry: 'computer',
          type: 'corporation',
          city: 'San Francisco',
          state: 'CA',
          postalCode: '90210',
          noEmployees: 10100,
          annualRevenue: null,
          timezone: '',
          description: '',
          linkedinUrl: '',
          companyWebsite: 'www.microsoft.com',
          createdAt: '2023-05-16T06:37:42.128Z',
          updatedAt: '2024-01-23T08:34:49.748Z',
          __v: 0,
          photoUrl:
            'https://ucarecdn.com/48b21a70-ce57-4e46-95d0-b3d6b9acebdd/',
          trashed: false,
          trashedAt: null,
          id: '646324b6f3a89fed15a2c229',
        },
        name: 'Deal1',
        type: 'NEW_BUSINESS',
        closedAt: '2023-09-14T16:00:00.000Z',
        sequence: 5,
        createdAt: '2023-06-01T07:39:24.072Z',
        updatedAt: '2024-01-04T01:42:08.323Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 1000,
        stageId: '64f94a605b1334b16062f3fd',
        _amount: '1,000.00',
      },
    ],
  },
};

export const mockCompanyData = {
  _id: '646324b6f3a89fed15a2c229',
  name: 'Microsofts',
  accountId: '63e05fe4d59adc087e305e08',
  industry: 'computer',
  type: 'corporation',
  city: 'San Francisco',
  state: 'CA',
  postalCode: '90210',
  noEmployees: 10100,
  annualRevenue: null,
  timezone: '',
  description: '',
  linkedinUrl: '',
  companyWebsite: 'www.microsoft.com',
  createdAt: '2023-05-16T06:37:42.128Z',
  updatedAt: '2024-01-23T08:34:49.748Z',
  __v: 0,
  photoUrl: 'https://ucarecdn.com/48b21a70-ce57-4e46-95d0-b3d6b9acebdd/',
  trashed: false,
  trashedAt: null,
  id: '646324b6f3a89fed15a2c229',
};
export const stages = [
  {
    _id: '646448397996bbe2b288426b',
    pipelineId: '6464375a74df66748857a3d7',
    sequence: 1,
    name: 'Stage2',
    actions: [],
    createdAt: '2023-05-17T03:21:29.839Z',
    updatedAt: '2023-05-30T03:09:28.106Z',
    trashed: false,
    trashedAt: null,
    __v: 0,
    id: '646448397996bbe2b288426b',
  },
  {
    _id: '646448467996bbe2b288427c',
    pipelineId: '6464375a74df66748857a3d7',
    sequence: 2,
    name: 'Stage1',
    actions: [],
    createdAt: '2023-05-17T03:21:42.546Z',
    updatedAt: '2023-05-17T03:40:03.720Z',
    trashed: false,
    trashedAt: null,
    __v: 0,
    id: '646448467996bbe2b288427c',
  },
  {
    _id: '646441abd973766a4dd62f28',
    pipelineId: '6464375a74df66748857a3d7',
    sequence: 3,
    name: 'Stage3',
    actions: [],
    createdAt: '2023-05-17T02:53:31.400Z',
    updatedAt: '2023-06-01T07:38:25.926Z',
    trashed: false,
    trashedAt: null,
    __v: 0,
    id: '646441abd973766a4dd62f28',
  },
  {
    _id: '64f94a605b1334b16062f3fd',
    pipelineId: '6464375a74df66748857a3d7',
    sequence: 4,
    name: 'Stage4',
    actions: [],
    createdAt: '2023-09-07T03:58:24.578Z',
    updatedAt: '2023-09-07T03:58:24.578Z',
    trashed: false,
    trashedAt: null,
    __v: 0,
    id: '64f94a605b1334b16062f3fd',
  },
];
